import { render, staticRenderFns } from "./OtherFilterWidget.vue?vue&type=template&id=6fd3fc7a&scoped=true&lang=pug&"
import script from "./OtherFilterWidget.vue?vue&type=script&lang=js&"
export * from "./OtherFilterWidget.vue?vue&type=script&lang=js&"
import style0 from "./OtherFilterWidget.vue?vue&type=style&index=0&id=6fd3fc7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd3fc7a",
  null
  
)

export default component.exports